module.exports = __webpack_public_path__ + "static/img/doding.2745769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/work/doding.png
// module id = bj92
// module chunks = 0